import { render } from "./Research.vue?vue&type=template&id=1fb1a612"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3524514966/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__